// extracted by mini-css-extract-plugin
export default {"h":"styles_h__M8wQJ","p":"styles_p__4rofT","box":"styles_box__EnRVG"};